
import { useEffect } from 'react';

const useSortedData = (data, sortBy, setData) => {
  useEffect(() => {
    const sortData = (data, sortBy) => {
        if (!Array.isArray(data)) {
            console.error("data is not an array");
            return [];
          }
      const sortedData = [...data];

      if (sortBy === "new-to-old") {
        sortedData.sort((a, b) => new Date(b.date) - new Date(a.date));
      } else if (sortBy === "old-to-new") {
        sortedData.sort((a, b) => new Date(a.date) - new Date(b.date));
      } else if (sortBy === "A-Z") {
        sortedData.sort((a, b) => {
          const titleA = a.title.rendered ? a.title.rendered.toLowerCase() : '';
          const titleB = b.title.rendered ? b.title.rendered.toLowerCase() : '';
          return titleA.localeCompare(titleB);
        });
      } else if (sortBy === "Z-A") {
        sortedData.sort((a, b) => {
          const titleA = a.title.rendered ? a.title.rendered.toLowerCase() : '';
          const titleB = b.title.rendered ? b.title.rendered.toLowerCase() : '';
          return titleB.localeCompare(titleA);
        });
      }

      return sortedData;
    };

    const newSortedData = sortData(data, sortBy);

    // Compare newSortedData with the current data using JSON.stringify
    if (JSON.stringify(newSortedData) !== JSON.stringify(data)) {
      setData(newSortedData); // Update state if newSortedData is different
    }
  }, [data, sortBy, setData]);
};

export default useSortedData;
